/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_2fa_ConfirmInputs */

const cs_settings_profile_2fa_confirm = /** @type {(inputs: Settings_Profile_2fa_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zadejte kód z aplikace a dokončete nastavení`)
};

const en_settings_profile_2fa_confirm = /** @type {(inputs: Settings_Profile_2fa_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a code from the app to finish setup`)
};

/**
* | output |
* | --- |
* | "Enter a code from the app to finish setup" |
*
* @param {Settings_Profile_2fa_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_2fa_confirm = /** @type {((inputs?: Settings_Profile_2fa_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_2fa_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_2fa_confirm(inputs)
	return cs_settings_profile_2fa_confirm(inputs)
});